import React, { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import Hero from '../components/Hero';
import BarraBusca from '../components/BarraBusca';
import Carregando from '../components/Carregando';
import { CardPasta, ListaDocumentos, Vazio } from '../components/Documentos';
import { useCatalogo, buscar } from '../services/catalogo';
import { pluralizar } from '../utils/formatar';
import useTitulo from '../utils/useTitulo';

function Busca() {
    const [params, setParams] = useSearchParams();
    const q = params.get('q') || '';
    const { carregando, erro, indice } = useCatalogo();
    useTitulo(q ? `Busca: ${q}` : 'Buscar documentos');

    const resultado = useMemo(() => (indice ? buscar(indice, q) : null), [indice, q]);

    // busca enquanto digita; "replace" evita encher o histórico do navegador
    const atualizar = (valor) => setParams(valor.trim() ? { q: valor } : {}, { replace: true });

    const total = resultado ? resultado.pastas.length + resultado.documentos.length : 0;

    return (
        <>
            <Hero
                titulo="Buscar documentos"
                breadcrumb={[{ texto: 'Início', to: '/' }, { texto: 'Busca' }]}
            >
                <BarraBusca
                    valor={q}
                    autoFoco
                    botao={false}
                    rotulo="Buscar documentos"
                    placeholder="Digite parte do nome, número ou assunto…"
                    aoDigitar={atualizar}
                    aoEnviar={atualizar}
                />
            </Hero>

            <div className="hub-corpo">
                <Container>
                    <Carregando carregando={carregando} erro={erro}>
                        {resultado && !q.trim() && (
                            <>
                                <p className="estado">
                                    Digite acima para buscar entre {indice.documentos.length} documentos, ou escolha uma pasta:
                                </p>
                                <div className="grade-pastas">
                                    {indice.raiz.map((p) => <CardPasta key={p.id} pasta={p} />)}
                                </div>
                            </>
                        )}

                        {resultado && q.trim() && (
                            <>
                                <p className="resultado-resumo" role="status" aria-live="polite">
                                    {total === 0
                                        ? <>Nenhum resultado para <strong>“{q}”</strong>.</>
                                        : <>{pluralizar(total, 'resultado', 'resultados')} para <strong>“{q}”</strong>.</>}
                                </p>

                                {resultado.pastas.length > 0 && (
                                    <section aria-labelledby="res-pastas" className="secao">
                                        <h2 id="res-pastas" className="secao__titulo">
                                            Pastas <span className="secao__contagem">({resultado.pastas.length})</span>
                                        </h2>
                                        <div className="grade-pastas">
                                            {resultado.pastas.map((p) => (
                                                <CardPasta key={p.id} pasta={p} termos={resultado.termos} />
                                            ))}
                                        </div>
                                    </section>
                                )}

                                {resultado.documentos.length > 0 && (
                                    <section aria-labelledby="res-docs" className="secao">
                                        <h2 id="res-docs" className="secao__titulo">
                                            Documentos <span className="secao__contagem">({resultado.documentos.length})</span>
                                        </h2>
                                        <ListaDocumentos
                                            documentos={resultado.documentos}
                                            termos={resultado.termos}
                                            mostrarCaminho
                                        />
                                    </section>
                                )}

                                {total === 0 && (
                                    <Vazio>
                                        Tente outras palavras ou menos termos. A busca ignora acentos e maiúsculas.
                                    </Vazio>
                                )}
                            </>
                        )}
                    </Carregando>
                </Container>
            </div>
        </>
    );
}

export default Busca;
